import { WizardPageContextType } from "@product-pages/common/types";
import React from "react";

const WizardPageContext = React.createContext<WizardPageContextType>({} as WizardPageContextType);

export const WizardPageContextProvider = WizardPageContext.Provider;

export const useWizardPageContext = () => React.useContext(WizardPageContext);
